import UIThemes, { UIThemesEnum } from '../../models/ui-themes.js'

export default {
  state: {
    isDisabled: false,
    isNext: false,
    endComponent: null,
    startComponent: null,
    selectedComponent: null,
    nextComponent: null,
    componentHistory: [],
    steps: [],
    currentStep: 0,
    paramns: [],
    beforeNextComponent: false,
    infoModal: false,
    cidModal: false,
    getSpecialties: {},
    theme: UIThemesEnum.DEFAULT
  },

  getters: {
    cidModal: (state) => {
      return state.cidModal
    },
    infoModal: (state) => {
      return state.infoModal
    },
    getSpecialties: (state) => {
      return state.getSpecialties
    },
    currentStep: (state) => {
      return state.currentStep
    },
    listSteps: (state) => {
      return state.steps
    },
    selectedComponent: (state) => {
      return state.selectedComponent
    },
    nextComponent: (state) => {
      return state.nextComponent
    },
    endComponent: (state) => {
      return state.endComponent
    },
    statusButton: (state) => {
      return state.isDisabled
    },
    historic: (state) => {
      return state.componentHistory
    },
    paramns: (state) => {
      return state.paramns
    },
    isHighContrastSelected: (state) => {
      return state.theme === UIThemesEnum.HIGH_CONTRAST
    }
  },

  mutations: {
    setEnd (state) {
      state.currentStep = 5
    },
    enableBeforeNextComponent (state) {
      state.beforeNextComponent = true
    },
    disableBeforeNextComponent (state) {
      state.beforeNextComponent = false
    },
    toggleCidModal (state) {
      state.cidModal = !state.cidModal
    },
    toggleModal (state) {
      state.infoModal = !state.infoModal
    },
    setSpecialties (state, value) {
      state.getSpecialties = value
    },
    setMyStep (state, value) {
      for (let i in state.steps) {
        if (state.steps[i].name === value) {
          state.currentStep = parseInt(i)
        }
      }
    },
    enableButton (state) {
      state.isDisabled = true
    },
    disableButton (state) {
      state.isDisabled = false
    },
    setNextFormComponent (state, value) {
      state.nextComponent = value
    },
    setPreviousFormComponent (state) {
      let previous = state.componentHistory
      state.selectedComponent = previous[previous.length - 1]
      previous.pop()
    },
    setStartEndFormComponent (state, value) {
      state.endComponent = value.last
      state.startComponent = value.first
    },
    setListComponent (state, value) {
      state.steps = value
    },
    setSelectedComponent (state, value) {
      if (state.beforeNextComponent && state.nextComponent !== 'Questions') {
        state.infoModal = true
      } else {
        state.selectedComponent = value
      }
    },
    setComponentHistory (state) {
      state.componentHistory.push(state.selectedComponent)
    },
    setUITheme (state, theme) {
      //
      let root = document.documentElement

      // Remover estilo atual
      UIThemes[state.theme].forEach(theme => {
        root.style.removeProperty(theme.name)
      })

      // Aplicar novo estilo
      state.theme = theme
      UIThemes[state.theme].forEach((theme) => {
        root.style.setProperty(theme.name, theme.value)
      })
    }
  },

  actions: {
    changeTo ({ commit }, payload) {
      commit('setSelectedComponent', payload)
    },
    includeFormData ({ commit }, payload) {
      commit('setStartEndFormComponent', payload)
      commit('setListComponent', payload.steps)
      commit('setSelectedComponent', payload.first)
    },
    changeToNextComponent ({ state, commit }) {
      if (state.nextComponent !== state.selectedComponent) {
        commit('setComponentHistory')
        commit('setSelectedComponent', state.nextComponent)
        commit('disableButton')
      }
    },
    changeToPreviousComponent ({ state, commit }) {
      commit('setPreviousFormComponent')
      commit('enableButton')
      if (
        state.previousChild === state.startComponent ||
        state.previousChild === state.endComponent
      ) {
        state.previousChild = null
      }
    },
    toggleInfoModal ({ commit }) {
      commit('toggleModal')
    }
  }
}
